import { useState } from 'react';
import { Button, Popconfirm, Tooltip } from 'antd';
import { FaTrash } from "react-icons/fa";
import useAdBlockStore from "store/AdBlockStore";

export const DeleteConfirmation = ({
    title = "Delete",
    description = "Are you sure?",
    tooltipText = "Delete",
    data = {}
}) => {
    const [open, setOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const removeOffer = useAdBlockStore((state) => state.removeOffer);
    const removeOfferByID = useAdBlockStore((state) => state.removeOfferByID);
    const removeIncentive = useAdBlockStore((state) => state.removeIncentive);
    const updateActiveBlockData = useAdBlockStore((state) => state.updateActiveBlockData);
    const [onRemoveFunc, setOnRemoveFunc] = useState(null);
    const [params, setParams] = useState(null);

    const handlePopConfirm = () => {
        if (data.type === 'offer') {
            if (data.obj?.uuid) {
                // delete offer by id
                setOnRemoveFunc(() => removeOfferByID)
                setParams(data.obj?.uuid)
                setOpen(true);
            } else {
                // delete offer locally
                removeOffer(data.obj?.index)
            }
        }
        else if (data.type === 'incentive') {
            if (data.obj?.isClonedIncentive || data.obj?.isAddedIncentive) {
                // delete incentive
                removeIncentive(data.obj.index);
                updateActiveBlockData({ offers_approved: false })
            } else {
                // delete approved incentive locally
                setOnRemoveFunc(() => removeIncentive)
                setParams(data.obj?.index)
                setOpen(true);
            }
        }

    };

    const handleOk = async () => {
        setConfirmLoading(true);
        await onRemoveFunc && onRemoveFunc(params);
        setOpen(false);
        setConfirmLoading(false);
    };

    const handleCancel = () => {
        console.log('Clicked cancel button');
        setOpen(false);
    };

    return (
        <Popconfirm
            title={title}
            description={description}
            open={open}
            onConfirm={handleOk}
            okButtonProps={{ loading: confirmLoading }}
            onCancel={handleCancel}
            placement='bottomLeft'
        >
            <Button type="link" size="small" style={{ padding: 0 }} onClick={handlePopConfirm}>
                <Tooltip title={tooltipText}>
                    <FaTrash color="var(--error-color)" />
                </Tooltip>
            </Button>
        </Popconfirm>
    );
};

